import { useState, useEffect, useMemo } from 'react';
import { useObserver } from 'mobx-react';
import { usePublisherStore } from '.';

function usePublisher() {
    const publisherStore = usePublisherStore();

    const [featuredPublishers, setFeaturedPublishers] = useState([]);
    const [featuredSection, setFeaturedSection] = useState({});
    const [whatshotPublishers, setWhatshotPublishers] = useState([]);
    const [popularNowPublishers, setPopularNowPublishers] = useState([]);
    const [nearMePublishers, setNearMePublishers] = useState([]);
    const [recommendedPublishers, setRecommendedPublishers] = useState([]);
    const [directoryPublishers, setDirectoryPublishers] = useState([]);
    const [masterDirectoryPublishers, setMasterDirectoryPublishers] = useState([]);
    const [directoryFilterIndustries, setDirectoryFilterIndustries] = useState([]);
    const [search, setSearch] = useState({
        whatshotEnabled: false,
        searchText: '',
        industryFilters: [],
    });

    const signals = useObserver(() => ({
        featuredPublishers: publisherStore.observed.featuredPublishers,
        whatshotPublishers: publisherStore.observed.whatshotPublishers,
        popularNowPublishers: publisherStore.observed.popularNowPublishers,
        nearMePublishers: publisherStore.observed.nearMePublishers,
        recommendedPublishers: publisherStore.observed.recommendedPublishers,
        directoryPublishers: publisherStore.observed.directoryPublishers,
        search: publisherStore.observed.search,
    }));

    useEffect(() => {
        setFeaturedPublishers(publisherStore.featuredPublishers);
        setFeaturedSection(publisherStore.featuredSection);
    }, [signals.featuredPublishers]);

    useEffect(() => {
        setWhatshotPublishers(publisherStore.whatshotPublishers);
    }, [signals.whatshotPublishers]);

    useEffect(() => {
        setPopularNowPublishers(publisherStore.popularNowPublishers);
    }, [signals.popularNowPublishers]);

    useEffect(() => {
        setNearMePublishers(publisherStore.nearMePublishers);
    }, [signals.nearMePublishers]);

    useEffect(() => {
        setRecommendedPublishers(publisherStore.recommendedPublishers);
    }, [signals.recommendedPublishers]);

    useEffect(() => {
        setDirectoryPublishers(publisherStore.directoryPublishers);
        setMasterDirectoryPublishers(publisherStore.masterDirectoryPublishers);
        setDirectoryFilterIndustries(publisherStore.directoryFilterIndustries);
    }, [signals.directoryPublishers]);

    useEffect(() => {
        setSearch({ ...publisherStore.search });
    }, [signals.search]);

    const filteredDirectoryPublishers = useMemo(() => {
        const { searchText, whatshotEnabled, industryFilters } = search;
        const q = searchText.trim().toLowerCase();
        const isSearchActive = q || industryFilters.length || whatshotEnabled;
        // Search across the full master list; show first-50 slice when idle
        const pool = isSearchActive ? masterDirectoryPublishers : directoryPublishers;
        return pool.filter((p) => {
            if (whatshotEnabled && !p.rank) return false;
            if (industryFilters.length && !industryFilters.some((c) => p.industries?.includes(c))) return false;
            if (q && !p.name.toLowerCase().includes(q) && !p.industries?.join(' ').toLowerCase().includes(q)) return false;
            return true;
        });
    }, [directoryPublishers, masterDirectoryPublishers, search]);

    return {
        featuredPublishers,
        featuredSection,
        whatshotPublishers,
        popularNowPublishers,
        nearMePublishers,
        recommendedPublishers,
        directoryPublishers,
        masterDirectoryPublishers,
        directoryFilterIndustries,
        filteredDirectoryPublishers,
        search,
    };
}

export default usePublisher;
